export default __webpack_public_path__ + "static/media/Pallid Engraver.42832513.jpg";